var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(" "+_vm._s(_vm.domain.domain)+" ")]),_c('td',[_c('a',{staticClass:"btn btn-icon btn-light btn-sm",attrs:{"href":"#"},on:{"click":function($event){return _vm.deleteDomainClicked()}}},[_c('span',{staticClass:"svg-icon svg-icon-md svg-icon-primary"},[_c('inline-svg',{attrs:{"src":"/assets/svg/Trash.svg"}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }